import { Component, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import { overlayConfigFactory } from 'angular2-modal';
import { BSModalContext, Modal } from 'angular2-modal/plugins/bootstrap';
import { ChangeEvent } from 'angular2-virtual-scroll';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { Subject } from 'rxjs';
import { AlertService } from '../../../sharedcomponents/commonservice/alert.service';
import { utilityService } from '../../../sharedcomponents/commonservice/utility.service';
import { ErrorPopupComponent } from '../../../sharedcomponents/_directive/error-popup/error-popup.component';
import { uploaddocumtuserprofilestep1 } from '../../../user/user-register/user-document-upload/userprofile-document-upload.component-Step1';
import { uploaddocumtuserprofilestep2 } from '../../../user/user-register/user-document-upload/userprofile-document-upload.component-Step2';
import { messagecenterService } from '../../../_services/messagecenter/messagecenterservice';
import { SendMoneyService } from '../../../_services/sendmoneyservice/sendmoneyservice';
import { enumStatusCodeList } from '../../_common/constants/app.constants';
import { MessageDetailComponent } from '../message-detail/message-detail.component';
import { InfoPopupComponent } from '../../../sharedcomponents/_directive/info-popup/info-popup.component';
export interface ListItem {
  Message?: string;
  Timestamp?: string;
}
@Component({
  selector: 'app-messagelist',
  templateUrl: './messagelist.component.html',
  styleUrls: ['./messagelist.component.css'],
  providers: [messagecenterService, AlertService]
})
export class MessagelistComponent implements OnInit {
  isAgentData: boolean = true;
  DocRequiredEventId: string = '953';
  FundingFailedEventId: string = '954';
  messageList: any = [];
  agentItems: any = [];
  DocumentRequired: {};
  unsubDocReq: any;
  loading;
  isFirstLoad = true;
  isData = false;
  selectedIndex;
  private subDocReq = new Subject<boolean>();
  messageModel: any = {};
  @Output()
  observableDocReq = this.subDocReq.asObservable();
  @Input()
  items: ListItem[];
  constructor(
    private alertService: AlertService,
    private msgCenter: messagecenterService,
    public utilserv: utilityService,
    public translate: TranslateService,
    public modal: Modal,
    private router: Router,
    private sendMoneyService: SendMoneyService,
    private vcRef: ViewContainerRef
  ) {
    this.messageModel.pageIndex = 0;
    this.messageModel.messageCount = 12;
  }

  ngOnInit() {
    this.getmessageResponse();
  }
  getmessageResponse() {
    this.utilserv.busy = this.msgCenter.getPromotionalCodeService(this.messageModel).subscribe(
      data => {
        this.isFirstLoad = false;
        let tempmessageList = [];
        if (data.Envelope.Body.NotificationResponse.StatusCode == enumStatusCodeList.SUCCESS) {
          if (data.Envelope.Body.NotificationResponse.Notifications.PersistNotification != undefined) {
            tempmessageList = this.utilserv.getArray(data.Envelope.Body.NotificationResponse.Notifications.PersistNotification);
            this.messageList = this.messageList.concat(tempmessageList);
            this.DocRequiredEventId = data.Envelope.Body.NotificationResponse.DocRequiredEventId;
            this.FundingFailedEventId = data.Envelope.Body.NotificationResponse.FundingFailedEventId;
          }

          if (tempmessageList.length < this.messageModel.messageCount) {
            this.isAgentData = false;
          }
          if (this.messageList.length == 0) {
            this.isAgentData = false;
          }
          // this.isData = true;

          // if (this.messageList.length <= 0) {
          //   this.isData = false;
          // }
        }
      },
      error => {
        console.log('Observer got a next value: ' + error);
      }
    );
  }
  openMessage(msgList, listIndex) {
    //    this.alertService.OpenInfoModal('', '', msgList.Message);

    this.selectedIndex = listIndex;

    this.utilserv.busy=this.msgCenter.readMessageService(this.utilserv.getObjectText(msgList.Id)).subscribe(data => {
      console.log('Observer got a next value: ' + data);
      const _self = this;
      const modalData: any = {};
      modalData.Title = ''; // this.translate.instant('MessageCenter_title').toString();
      modalData.Message = msgList.Message; // this.translate.instant('popupMessage_ThankYouPopup').toString();
      modalData.Action = this.translate.instant('Common_lblContinue').toString();

      if (_self.utilserv.getObjectText(msgList.EventId) == _self.FundingFailedEventId || _self.utilserv.getObjectText(msgList.EventId) == _self.DocRequiredEventId) {
        modalData.isContinueVisible = true;
      } else {
        modalData.isContinueVisible = false;
      }

      modalData.msgListData = msgList;
      if (this.modal.overlay.defaultViewContainer == undefined) {
        this.modal.overlay.defaultViewContainer = this.vcRef;
      }
      return this.modal.open(MessageDetailComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
        obj.onDestroy.subscribe(data => {
          console.log('Observer got a next value: ' + data);
          if (modalData.next == 'yes') {
            if (_self.utilserv.getObjectText(modalData.msgListData.EventId) == _self.FundingFailedEventId) {
              _self.router.navigate(['/transactionlist']);
            } else if (_self.utilserv.getObjectText(modalData.msgListData.EventId) == _self.DocRequiredEventId) {
              _self.isdocumentRequiredCheck();
              _self.unsubDocReq = _self.observableDocReq.subscribe(isDocumentRequired => {
                if (isDocumentRequired == true) {
                  _self.uploadDocument();
                } else {
                  _self.messageList = [];
                  _self.isAgentData = true;
                  _self.messageModel.pageIndex = 0;
                  _self.messageModel.messageCount = 12;
                  _self.getmessageResponse();
                }
                _self.unsubDocReq.unsubscribe();
              });
            }
          } else {
            // _self.messageList = [];
            // _self.getmessageResponse();
          }
        });
      });
    });
  }
  uploadDocument() {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    const _self = this;
    const modalData: any = {};
    modalData.DocumentRequired = this.DocumentRequired;
    this.modal.open(uploaddocumtuserprofilestep1, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.Status == false) {
          return;
        }
        console.log('Observer got a next value: ' + data);
        if (modalData.Status == true) {
          modalData.Status = false;
          return _self.modal.open(uploaddocumtuserprofilestep2, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
            obj.onDestroy.subscribe(data => {
              console.log('Observer got a next value: ' + data);
              if (modalData.Status == false) {
                return;
              }
              if (modalData.Status == true) {
              } else {
                _self.errorPopup(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
              }
            });
          });
        } else {
          this.errorPopup(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
        }
      });
    });
  }
  errorPopup(title, message) {
    this.modal.overlay.defaultViewContainer = this.vcRef;
    let modalData: any = {};
    modalData.Title = title;
    modalData.Message = message;
    this.modal.open(ErrorPopupComponent, overlayConfigFactory({ modalData }, BSModalContext));
  }

  isdocumentRequiredCheck() {
    // some code here
    this.utilserv.busy = this.sendMoneyService.documentRequiredCheck().subscribe(data => {
      if (data.Envelope.Body.DocumentRequiredResponse.StatusCode == enumStatusCodeList.SUCCESS) {
        if (
          data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxID == 'true' ||
          data.Envelope.Body.DocumentRequiredResponse.RequireCustomerTaxIdForUSID == 'true' ||
          data.Envelope.Body.DocumentRequiredResponse.RequireCustomerID == 'true'
        ) {
          this.DocumentRequired = data.Envelope.Body.DocumentRequiredResponse;
          this.subDocReq.next(true);
        } else {
          this.subDocReq.next(false);
        }
      } else {
        // this.errorPopup(this.translate.instant('Common_lblOops'), this.translate.instant('popupMessage_Popup'));
      }
    });
  }
  fetchMore(event: ChangeEvent) {
    if (this.isAgentData == false) return;
    if (event.end !== this.messageList.length) {
      return;
    }

    // this.loading = true;
    this.fetchNextChunk().then(
      chunk => {
        this.messageList = this.messageList.concat(chunk);
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  fetchNextChunk(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      // this.searchForPayer();
      console.log('Observer got a next value: ' + resolve + reject);
      this.messageModel.pageIndex += 1;
      // this.messageModel.messageCount = limit;
      this.getmessageResponse();
    });
  }
  gotoDashBoard() {
    this.router.navigate(['/dashboard']);
  }
  deleteMessage(msg) {
    const msgId = this.utilserv.getObjectText(msg.Id);
    const _self = this;
    const modalData: any = {};
    modalData.Title = this.translate.instant('Common_lblConfirm');
    modalData.Message = _self.translate.instant('MessageCenter_lblDeleteDesc');
    return _self.modal.open(InfoPopupComponent, overlayConfigFactory({ modalData }, BSModalContext)).then(function (obj) {
      obj.onDestroy.subscribe(data => {
        if (modalData.next == 'yes') {
          _self.utilserv.busy = _self.msgCenter.deleteMessageService(msgId).subscribe(data => {
            if (data.Envelope.Body.NotificationInformationResponse.StatusCode == enumStatusCodeList.SUCCESS) {
              const tempMessageList = [];
              _self.messageList.forEach(element => {
                if (_self.utilserv.getObjectText(element.Id) != msgId) {
                  tempMessageList.push(element);
                }
              });
              _self.messageList = [];

              _self.messageList = tempMessageList;
            } else {
              _self.alertService.openErrorAlert(_self.translate.instant('Common_lblOops'), _self.translate.instant('Message_errorMessage'));
            }
          });
        }
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/messagecenter/messagelist/messagelist.component.ts